import React, {PropTypes} from 'react';
import InfiniteCalendar from 'react-infinite-calendar';

const calendarTheme = {
  selectionColor: 'rgb(0,51,141)',
  textColor: {
   default: 'rgb(99,102,106)',
   active: 'rgb(255,255,255)'
  },
  weekdayColor: 'rgb(58,113,210)',
  headerColor: 'rgb(0,51,141)',
  floatingNav: {
   background: 'rgba(58,113,210,0.96)',
   color: 'rgb(255,255,255)',
   chevron: 'rgb(84,207,112)'
  }
};

const RegistrationCalendar = ({
  visible,
  selectedDate,
  disabledDates,
  min,
  minDate,
  max,
  maxDate,
  onSelectDate
}) => (
  <div>
    {
      visible
      ? <div className="panel panel-default calendar-div">
          <InfiniteCalendar
            theme={calendarTheme}
            width="100%"
            height={336}
            keyboardSupport={true}
            disabledDates={disabledDates}
            onSelect={onSelectDate}
            selectedDate={selectedDate}
            min={min}
            minDate={minDate}
            max={max}
            maxDate={maxDate}
            showTodayHelper={false}
          />
        </div>
      : null
    }
  </div>
);

RegistrationCalendar.propTypes = {
  visible: PropTypes.bool,
  selectedDate: PropTypes.string,
  disabledDates: PropTypes.arrayOf(PropTypes.string),
  min: PropTypes.string,
  minDate: PropTypes.string,
  max: PropTypes.string,
  maxDate: PropTypes.string,
  onSelectDate: PropTypes.func
};

export default RegistrationCalendar;



// WEBPACK FOOTER //
// ./src/features/shared/RegistrationCalendar.jsx